import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Formx from '@/components/Formx'
import List from '@/components/List'
import Configx from '@/components/Configx'
import Mapx from '@/components/Mapx'
import Dashboard from '@/components/Dashboard'
import Checklist from '@/components/inspection/Checklist'
import PrintHoldpoint from '@/components/inspection/PrintHoldpoint'
import RdioView from '@/components/rdio/View'
import ReportePatrullaje from '@/components/catodico/ReportePatrullaje'
import ReporteMedicion from '@/components/catodico/ReporteMedicion'
import Log from '@/components/Log'
import Ot from '@/components/inspection/Ot'
import DashboardLote from '@/components/DashboardLote'
import test from '@/components/Test'
import manual from '@/components/Manual'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/dashboardLote/:typex/:json',
      name: 'dashboardLote',
      component: DashboardLote
    },
    {
      path: '/form/:typex/:json/:id',
      name: 'form',
      component: Formx
    },
    {
      path: '/list/:typex/:json',
      name: 'list',
      component: List
    },
    {
      path: '/map/:typex/:json',
      name: 'map',
      component: Mapx
    },
    {
      path: '/dashboard/:typex/:json',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/config',
      name: 'config',
      component: Configx
    },
    {
      path: '/checklist/:typex/:json/:id',
      name: 'inspection_view',
      component: Checklist,
      props: true
    },
    {
      path: '/holdpoint/:typex/:json/:id',
      name: 'holdpoint',
      component: PrintHoldpoint
    },
    {
      path: '/ot/:typex/:json/',
      name: 'ot',
      component: Ot,
      props: true
    },
    {
      path: '/view/:typex/:json/:id',
      name: 'rdio_view',
      component: RdioView,
      props: true
    },
    {
      path: '/catodico_patrullaje/:typex/:json/:id',
      name: 'catodico_patrullaje_view',
      component: ReportePatrullaje,
      props: true
    },
    {
      path: '/catodico/:typex/:json/:id',
      name: 'catodico_view',
      component: ReporteMedicion,
      props: true
    },
    {
      path: '/log',
      name: 'log',
      component: Log
    },
    {
      path: '/test',
      name: 'test',
      component: test,
      props: true
    },
    {
      path: '/manual',
      name: 'manual',
      component: manual,
      props: true
    }
  ]
})
